import styled from "styled-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export const TickIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.success};
  height: 1rem;
  width: 1rem;
`

export const TimelineContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 360px;
`

export const TimelineItem = styled.div`
  display: flex;
  gap: 16px;
  position: relative;
  padding-bottom: 32px;

  &:last-child {
    padding-bottom: 0;
  }
`

export const Title = styled.div`
  font-size: 16px;
  color: ${({ isActive, theme }) => (isActive ? theme.colors.primary : "#333")};
  font-weight: ${({ isActive }) => (isActive ? "700" : "500")};
  line-height: 24px;
`

export const DateText = styled.div`
  font-size: 14px;
  color: #666;
  line-height: 24px;
`

export const CountdownWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  margin-top: 1rem;
`

export const Countdown = styled.div`
  display: flex;
  padding: 8px;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;
  background-color: #f7f7f7;
  border-radius: 8px;
`

export const Circle = styled.div`
  display: flex;
  width: 4px;
  height: 4px;
  padding: 10px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background-color: ${({ isActive, theme }) => (isActive ? theme.colors.primary : "#fff")};
  border-radius: 30px;
  border: 1px solid
    ${({ isActive, isCompleted, theme }) => (isActive ? "transparent" : isCompleted ? theme.colors.success : "#cccccc")};
`

export const ItemNumber = styled.p`
  font-size: 16px;
  color: ${({ isActive }) => (isActive ? "#fff" : "#333")};
  font-weight: 300;
`

export const Line = styled.div`
  position: absolute;
  left: 11px;
  top: 20px;
  width: 1px;
  height: 100%;
  background-color: #cccccc;
  z-index: -1;
`

export const ItemDayText = styled.p`
  color: #333;
  text-align: center;
  font-size: 16px;
  line-height: 150%;
  margin: 0;
  margin-bottom: 4px;
  font-weight: bold;
`

export const ItemUnitText = styled.p`
  color: #666;
  text-align: center;
  font-size: 16px;
  margin: 0;
`

export const Div = styled.div`
  width: 100%;
`
